import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import { Box, IconButton, Paper, Stack, Typography } from '@mui/material';
import { ReactNode } from 'react';
import { EnterpretLogoFull } from '@modules/common/components/EnterpretLogoFull';

interface AuthenticationCardWrapperProps {
  children?: ReactNode;
  onGoBack?: () => void;
  width?: number;
}

export const AuthenticationCardWrapper = ({
  children = null,
  width = 500,
  onGoBack,
}: AuthenticationCardWrapperProps) => {
  return (
    <Stack height="100vh" alignItems="center" justifyContent="center" mt={-8}>
      <Box width={width}>
        {onGoBack && (
          <IconButton onClick={onGoBack} sx={{ left: '-8px', mb: 1 }}>
            <KeyboardBackspaceIcon />
          </IconButton>
        )}
        <Paper
          variant="outlined"
          sx={{
            p: 4,
            borderRadius: 1,
          }}
        >
          <Stack alignItems="center" spacing={1} mb={4}>
            <Typography variant="h6" color="text.secondary">
              Welcome to
            </Typography>
            <EnterpretLogoFull width="165" height="35" />
          </Stack>
          {children}
        </Paper>
      </Box>
    </Stack>
  );
};
